var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td'),_c('td',{on:{"click":_vm.showJDModal}},[_vm._v(_vm._s(_vm.createdDate))]),_c('td',{domProps:{"innerHTML":_vm._s(_vm.highlightedJobTitle)},on:{"click":function($event){return _vm.matchJobseekers(_vm.jd)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }